module.exports = __webpack_public_path__ + "img/prize-image.39d174ec.png";